import React, { useState } from "react";
import MonthYearFilter from "../../Attendance/utils/MothYearFilter";
import { Trash } from "lucide-react";
import GoalProgress from "../../Attendance/GoalProgress";
import { useGoals } from "../../Attendance/hooks/useGoals";
import { getGoalParameters } from "../../Attendance/utils/parameters";

const PerformanceGoal = ({ employeeId }: { employeeId: number }) => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const filters = {
    employeeId,
    month,
    year,
  };

  const { data: goal, isLoading } = useGoals(filters);

  const parameters = goal ? getGoalParameters(goal) : undefined;

  const clearFilter = () => {
    setMonth("");
    setYear("");
  };

  return (
    <div className="p-2 w-full">
      <div>
        <div className="rounded-lg flex gap-4 justify-center items-center p-3 ">
          <MonthYearFilter
            month={month}
            year={year}
            onChange={({ month, year }) => {
              setMonth(month);
              setYear(year);
            }}
          />
          <button
            className="rounded-full border p-2 hover:border-red-500 hover:text-red-500 bg-red-50 shadow-md transition-all ease-in-out duration-300"
            onClick={clearFilter}
          >
            <Trash className="size-3.5" />
          </button>
        </div>

        {isLoading ? (
          <div className="w-full flex flex-col items-center justify-center min-h-40">
            <p className="my-4">Loading Goals...</p>
            <span className="loading loading-spinner loading-lg"></span>
          </div>
        ) : (
          <GoalProgress parameters={parameters} />
        )}
      </div>
    </div>
  );
};

export default PerformanceGoal;
